'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const JournalOverviewBox = styled(Box)(({theme}) => ({
    margin: 0,
    '> p': {
        margin: 0,
        color: theme.palette.text.primary,
    },
}));

export default JournalOverviewBox;
